module.exports = __webpack_public_path__ + "static/media/login.ee99a0aa.png";